import {
    NavLink
  } from "react-router-dom";
import {BsFillHouseFill,BsFillMenuButtonWideFill,BsCashCoin,BsArchiveFill,BsJournals} from 'react-icons/bs';
import { useEffect,useState,useContext,useCallback } from "react";
import UserContext from "../../contexts/UserContext";

  

const BottomNav = () => {
    const {user,setUser} = useContext(UserContext);

    const design = (
        <>
        {user?
        <div className="bottom-navigation-container">
            <NavLink to="/home" className="navigation-item">
                <BsFillHouseFill size={20}/>
                <span>Home</span>
            </NavLink>
            <NavLink to="/menu" className="navigation-item">
                <BsFillMenuButtonWideFill size={20}/>
                <span>Menu</span>
            </NavLink>
            <NavLink to="/rsvp" className="navigation-item">
                <BsArchiveFill size={20}/>
                <span>Fill Req</span>
            </NavLink>
            <NavLink to="/feedback" className="navigation-item">
                <BsJournals size={20}/>
                <span>Feedback</span>
            </NavLink>
            <NavLink to="/userPayment" className="navigation-item">
                <BsCashCoin size={20}/>
                <span>Payments</span>
            </NavLink>
        </div>:null}
        </>
    )
    return design;
}

export default BottomNav;